import { Box, Skeleton } from "@mui/material";
import useStyles from "./Styles";

const data = [1, 2, 3, 4];

const PendingSkeleton = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.gridSkeleton}>
      <Box sx={{ marginTop: 3 }} />
      {data.map((item: any) => {
        return (
          <Box
            key={item}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: 2,
              opacity: 0.5,
            }}
          >
            <Skeleton
              animation="wave"
              variant="circular"
              width={65}
              height={55}
            />
            <Skeleton
              animation="wave"
              variant="text"
              height={40}
              sx={{ marginLeft: 2, width: "100%" }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default PendingSkeleton;
